export default __webpack_public_path__ + "static/media/David1.ebd9fa40.png";